<template>
  <div v-if="display" style="margin-top: 30px; margin-bottom: 30px">
    <b-row v-for="sensorName in sortedSensorNames" :key="sensorName">
      <b-col>
        <div class="sensor-name">
          {{ getTranslationSensorName(sensorName) }}
        </div>
        <div class="sensor-details">
          <div class="info-block">
            <div class="key">Status:</div>
            <div class="value" 
     :class="{ 
       'is-close': display.status[sensorName].value === 'CLOSED', 
       'is-normal': display.status[sensorName].value === 'NORMAL', 
       'is-not-normal': display.status[sensorName].value === 'ERROR' && display.status[sensorName].value !== 'OPEN' && display.status[sensorName].value !== 'CLOSED'
     }">
              {{ getStatusValue(display.status[sensorName]) }}
            </div>
          </div>
          <div class="info-block">
            <div class="key">{{ $t('overview.updated') }}</div>
            <div class="value">
              {{
                formatMillisecondsToDatetime(
                  display.status[sensorName].timestamp
                )
              }}
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['display'],
  computed: {
    sortedSensorNames() {
      return Object.keys(this.display.status).sort()
    },
  },
  methods: {
    getStatusValue(statusDetails) {
      if (
        statusDetails.shock_sensor_low ||
        statusDetails.shock_sensor_high ||
        statusDetails.startup_time ||
        statusDetails.tts_button
      )
        return this.formatTimestamp(statusDetails.value)
      else {
        return this.getTranslationSensorValue(statusDetails.value)
      }
    },

    formatTimestamp(ts) {
      var time = ''
      try {
        time = new moment(ts, 'YYYY-MM-DD[T]HH:mm:ssZZ').format(
          'DD.MM.YYYY HH:mm:ss'
        )
        if (time.startsWith('Invalid')) time = ''
      } catch (err) {
        time = ''
      }
      return time
    },

    formatMillisecondsToDatetime(milliseconds) {
      const duration = moment(milliseconds)
      return duration.format('DD.MM.YYYY HH:mm:ss', { trim: false })
      //   return new Date(milliseconds)
    },
    getTranslationSensorName(name) {
      const key = 'sse_displays.status_info.' + name.toLowerCase()
      if (this.$te(key)) return this.$t(key)
      else return name
    },
    getTranslationSensorValue(value) {
      const key = 'sse_displays.status_info.values.' + value.toLowerCase()
      if (this.$te(key)) return this.$t(key)
      else return value
    },
  },
}
</script>

<style scoped lang="scss">
.row {
  font-size: 0.75rem;
  white-space: pre-wrap;
  margin-bottom: 2px;
}

.col {
  border-bottom: 1px solid #cecece;
  padding-bottom: 2px;
}

.sensor-name {
  font-weight: bold;
  margin-bottom: 1px;
}

.sensor-details {
  margin-left: 20px;
}

.info-block {
  display: flex;
  align-items: center;
}

.key {
  font-weight: bold;
  margin-right: 5px;
}

.value {
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.value.is-close {
  color: green;
}

.value.is-normal {
  color: green;
}

.value.is-not-normal {
  color: red;
}
</style>
